import { defaultInitialState, loadingState, updatedState, getErrorState } from '../utils';
import { SET_DATA_OPTOUT, SET_DATA_OPTOUT_DONE, SET_DATA_OPTOUT_ERR, SET_DATA_OPTOUT_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DATA_OPTOUT:
            return Object.assign(Object.assign({}, state), loadingState);
        case SET_DATA_OPTOUT_DONE:
            return Object.assign(Object.assign({}, state), updatedState);
        case SET_DATA_OPTOUT_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case SET_DATA_OPTOUT_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map